import { render, staticRenderFns } from "./ai-scriptwriter.vue?vue&type=template&id=2e7c3a09&scoped=true&"
import script from "./ai-scriptwriter.vue?vue&type=script&lang=js&"
export * from "./ai-scriptwriter.vue?vue&type=script&lang=js&"
import style0 from "./ai-scriptwriter.vue?vue&type=style&index=0&id=2e7c3a09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c3a09",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeFaqs: require('/opt/render/project/src/channels2022/src/components/home-page/HomeFaqs.vue').default})
